var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.448 18.919c.237-.935.363-1.913.363-2.92.001-6.523-5.287-11.811-11.81-11.811-5.148-.001-9.527 3.293-11.144 7.888h14.622a1.824 1.824 0 1 1 0 2.098H4.33A11.9 11.9 0 0 0 4.188 16c-.001 6.523 5.287 11.811 11.81 11.811 4.73.001 8.81-2.779 10.696-6.794H12.613a1.824 1.824 0 1 1 0-2.098h14.835zM16 29.999c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMob);
export default __webpack_public_path__ + "static/media/MOB.0a05864db3ae97c37aae1279edaf7544.svg";
export { ForwardRef as ReactComponent };